
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsLayout from '../../components/feature/NewsLayout';

interface Article {
  id: string;
  title: string;
  content: string;
  category: string;
  excerpt: string;
  image_url: string;
  author: string;
  published_at: string;
  tags: string[];
  view_count: number;
}

export default function AstrologyPage() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAstrologyArticles();
  }, []);

  const fetchAstrologyArticles = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles?category=星座運勢&limit=50`,
        {
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
          },
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        setArticles(data.articles || []);
      }
    } catch (error) {
      console.error('獲取星座文章失敗:', error);
      setArticles(getDefaultAstrologyArticles());
    } finally {
      setLoading(false);
    }
  };

  const getDefaultAstrologyArticles = () => [
    {
      id: 'astro1',
      title: '2024年十二星座年度運勢大解析：把握全年機遇',
      excerpt: '全面解析2024年十二星座的愛情、事業、財運和健康運勢，助您把握全年機遇，規劃美好未來...',
      published_at: '2024-01-15T08:30:00Z',
      category: '星座運勢',
      image_url: 'https://public.readdy.ai/ai/img_res/ae9114f8df3a09d49ea3a581dcf0023c.jpg',
      author: '星座專家 Stella',
      content: '',
      tags: ['星座', '運勢', '2024'],
      view_count: 3312
    },
    {
      id: 'astro2',
      title: '水逆期間如何化解負面影響：轉危為機的智慧',
      excerpt: '水星逆行期間容易出現溝通問題和計劃延誤，學會正確應對方法，化危機為轉機，提升個人能量...',
      published_at: '2024-01-14T12:15:00Z',
      category: '星座運勢',
      image_url: 'https://readdy.ai/api/search-image?query=Mercury%20planet%20in%20retrograde%20motion%20with%20cosmic%20background%2C%20mystical%20space%20scene%20with%20swirling%20galaxies%2C%20blue%20and%20silver%20celestial%20atmosphere&width=400&height=250&seq=astro2&orientation=landscape',
      author: '星座專家 Stella',
      content: '',
      tags: ['星座', '水逆', '化解'],
      view_count: 2267
    },
    {
      id: 'astro3',
      title: '星座配對指南：找到你的靈魂伴侶',
      excerpt: '深入分析十二星座的愛情特質和配對指數，幫助您找到最適合的另一半，建立幸福美滿的關係...',
      published_at: '2024-01-13T17:20:00Z',
      category: '星座運勢',
      image_url: 'https://readdy.ai/api/search-image?query=Romantic%20zodiac%20symbols%20intertwined%20in%20cosmic%20love%20scene%2C%20heart-shaped%20constellation%20with%20pink%20and%20gold%20starlight%2C%20dreamy%20celestial%20romance%20atmosphere&width=400&height=250&seq=astro3&orientation=landscape',
      author: '星座專家 Stella',
      content: '',
      tags: ['星座', '配對', '愛情'],
      view_count: 2889
    },
    {
      id: 'astro4',
      title: '月相對十二星座的影響：跟隨月亮節奏生活',
      excerpt: '了解不同月相對各星座的影響，學會跟隨月亮的節奏調整生活步調，提升運勢能量...',
      published_at: '2024-01-12T19:45:00Z',
      category: '星座運勢',
      image_url: 'https://readdy.ai/api/search-image?query=Moon%20phases%20with%20zodiac%20symbols%2C%20lunar%20cycle%20in%20starry%20sky%2C%20mystical%20moonlight%20illuminating%20constellation%20patterns%2C%20silver%20and%20blue%20atmosphere&width=400&height=250&seq=astro4&orientation=landscape',
      author: '星座專家 Stella',
      content: '',
      tags: ['星座', '月相', '能量'],
      view_count: 1756
    },
    {
      id: 'astro5',
      title: '火象星座本週運勢：牡羊、獅子、射手座指南',
      excerpt: '火象星座本週運勢詳解，包含愛情、事業、財運各方面的發展趨勢和注意事項...',
      published_at: '2024-01-11T15:30:00Z',
      category: '星座運勢',
      image_url: 'https://readdy.ai/api/search-image?query=Fire%20element%20zodiac%20signs%20with%20flames%20and%20stars%2C%20Aries%20Leo%20Sagittarius%20symbols%2C%20dynamic%20energy%20with%20red%20and%20orange%20cosmic%20fire&width=400&height=250&seq=astro5&orientation=landscape',
      author: '星座專家 Stella',
      content: '',
      tags: ['星座', '火象', '週運勢'],
      view_count: 1543
    },
    {
      id: 'astro6',
      title: '土象星座理財指南：金牛、處女、摩羯座財運分析',
      excerpt: '土象星座的理財特質分析，提供專屬的投資建議和財富累積策略，助您穩健增財...',
      published_at: '2024-01-10T13:10:00Z',
      category: '星座運勢',
      image_url: 'https://readdy.ai/api/search-image?query=Earth%20element%20zodiac%20signs%20with%20golden%20coins%20and%20crystals%2C%20Taurus%20Virgo%20Capricorn%20symbols%2C%20stable%20wealth%20energy%20with%20green%20and%20brown%20tones&width=400&height=250&seq=astro6&orientation=landscape',
      author: '星座專家 Stella',
      content: '',
      tags: ['星座', '土象', '理財'],
      view_count: 1987
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <NewsLayout 
        articles={articles}
        loading={loading}
        category="星座運勢"
        categoryColor="bg-blue-600"
      />
      <Footer />
    </div>
  );
}
